import React from 'react';

import classNames from 'classnames';

import Card from './DashboardCard';

// IB-677 rework — the per-type "focus table" (wireframe table.items): compact,
// uppercase headers, RAG dots and status chips. Rebuilt off the wireframe rather
// than the legacy inbud-table so density/palette match the rest of the rework.

// RAG dot: rag ∈ 'r' | 'a' | 'g'.
export function RagDot({ rag }) {
    const cls = { r: 'tw-bg-red', a: 'tw-bg-red-50', g: 'tw-bg-green' }[rag] || 'tw-bg-charcoal-25';

    return <span className={classNames('tw-inline-block tw-h-2.5 tw-w-2.5 tw-rounded-full tw-mr-1.5 tw-align-middle', cls)} />;
}

// Status chip: tone ∈ 'overdue' | undefined (neutral).
// PR review (#1060): 'track' was never invoked anywhere in the RADIO dashboards (and
// carried a stray #00805a hex outside the palette) — trimmed to the tones actually
// used. Add it back only alongside a real call site, on a palette/token colour.
export function Chip({ tone, children }) {
    const cls = tone === 'overdue' ? 'tw-bg-red-25 tw-text-red' : 'tw-bg-background tw-text-charcoal-75';

    return <span className={classNames('tw-inline-block tw-text-2xs tw-font-medium tw-rounded-full tw-px-2 tw-py-0.5', cls)}>{children}</span>;
}

// columns: [string]; rows: [[cellNode, ...]] (first cell gets the emphasised name style).
export default function FocusTable({ title, flag, columns, rows, empty }) {
    return (
        <Card title={title} flag={flag}>
            {rows && rows.length ? (
                <div className="tw-overflow-x-auto">
                    <table className="tw-w-full tw-border-collapse tw-text-xs">
                        <thead>
                            <tr>
                                {columns.map((column, index) => (
                                    <th
                                        key={index}
                                        className="tw-text-start tw-font-medium tw-uppercase tw-tracking-wide tw-text-2xs tw-text-charcoal-50 tw-border-b tw-border-grey tw-px-2 tw-py-2"
                                    >
                                        {column}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {row.map((cell, cellIndex) => (
                                        <td
                                            key={cellIndex}
                                            className={classNames(
                                                'tw-border-b tw-border-grey tw-px-2 tw-py-2 tw-align-middle',
                                                cellIndex === 0 ? 'tw-font-medium tw-text-charcoal' : 'tw-text-charcoal-75',
                                            )}
                                        >
                                            {cell}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="tw-text-sm tw-text-charcoal-50">{empty}</div>
            )}
        </Card>
    );
}
